import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'close-event-dialog',
    template: `
<div class="joi-dialog">
  <div mat-dialog-title class="warn">
      Close Event
  </div>
  <div mat-dialog-content class="content">
      <div class="note">
          <div class="head2">Important:</div>
          <div class="desc">Closing this event will mean that it becomes permanently read-only and you will not be able to make any further changes.</div>
      </div>
  </div>
  <div mat-dialog-actions>
      <button mat-button (click)="dialog.close()">Cancel</button>
      <button mat-button color="warn" (click)="dialog.close(true)" [disabled]="false">Close Event</button>
  </div>
</div>
`,
    styles: [`
  .joi-dialog .note { margin-bottom:30px; }
  .joi-dialog .head2 { text-transform: uppercase; font-weight:bold; color: #F05454;line-height: 20px; }
  .joi-dialog .desc { line-height: 20px; }
  .joi-dialog .title3 { font-weight:bold; margin-bottom: 20px;}
  .joi-dialog .mat-radio-button { margin-right:40px; }
 `],

    standalone: true,
    imports: [MatButtonModule],
})
export class CloseEventDialogComponent {
  constructor(public dialog: MatDialogRef<CloseEventDialogComponent>) { }
}